
export const daysInEnglishShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];


export function getWeekday(date: string): string {
    if (date) {
        const daysInEnglish = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const d = new Date(date);
        return daysInEnglish[d.getDay()];
    }
    return "";
}

export function getWeekdayShort(date: string): string {
    if (date) {
        const d = new Date(date);
        return daysInEnglishShort[d.getDay()];
    }
    return "";
}
